import { render } from "./ResultTest.vue?vue&type=template&id=5d2078ae&scoped=true&ts=true"
import script from "./ResultTest.vue?vue&type=script&lang=ts"
export * from "./ResultTest.vue?vue&type=script&lang=ts"

import "./ResultTest.vue?vue&type=style&index=0&id=5d2078ae&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2078ae"]])

export default __exports__